import React from 'react';

import moment from 'moment'

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {DateInput, Title, required, SelectInput} from 'react-admin';
import {ReportForm, IFrameHtmlReport, downloadFile, schoolYears} from '../../components';
import env from '../../env';

const printReceiptSelect = [
  { id: 'true', name: 'Phí xuất hoá đơn' },
  { id: 'false',   name: 'Phí xuất biên lai' },
]

class PaymentByDaysReport extends React.Component {
  state = {
    htmlReportUrl: '',
    fromDate: moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    printReceipt: null,
  };

  getReportUrl = (type) => {
    return `${env.baseURL}/reports/payments/byDays?type=` + type +
        `&pFromDate=` + this.state.fromDate +
        `&pToDate=` + this.state.toDate +
        `&pPrintReceipt=` + this.state.printReceipt;
  }

  excelReport = () => {
    downloadFile(this.getReportUrl('XLS'), 'bao_cao_thu_theo_ngay.xlsx')
  };

  validate = (values) => {
    const errors = {};
    // Validate
    if (values.fromDate && values.toDate && (values.fromDate > values.toDate) ){
      errors.toDate = 'To date must be greater than From date'
    }
    // Copy input values to params
    this.setState(values);

    return errors;
  };
  
  render() {
    return (
      <Card>
        <Title title="resources.paymentByDaysReport.name" />
        <CardContent>
          <ReportForm params={this.state}
            validate={this.validate} 
            excelReport={this.excelReport}
          >
            <Grid container spacing={8}>
              <Grid item xs={12} sm={6} >
                <DateInput label="resources.common.fromDate" source="fromDate" validate={required()} {...this.props} />
              </Grid>
              <Grid item xs={12} sm={6} >
                <DateInput label="resources.common.toDate" source="toDate" validate={required()} {...this.props} />
              </Grid>
              <Grid item xs={12} sm={6} >
                <SelectInput source="printReceipt"
                             label="Loại phí"
                             allowEmpty
                             choices={printReceiptSelect}/>
              </Grid>

            </Grid>
          </ReportForm>
        </CardContent>
      </Card>      
    )
  }
}

export default PaymentByDaysReport;

